module.exports = __webpack_public_path__ + "img/QQ_white_icon.a85fe1a3.png";